export default [
  {
    path: '/app/list',
    name: 'appList',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "appList" */ '@/views-app/video-list/index.vue'),
  },
  {
    path: '/app/live',
    name: 'appLive',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "appLive" */ '@/views-app/live/index.vue'),
  },
  {
    path: '/app/video',
    name: 'appVideo',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "appVideo" */ '@/views-app/video/index.vue'),
  },
  {
    path: '/app/report',
    name: 'appReport',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "appReport" */ '@/views-app/report/index.vue'),
  },
  {
    path: '/app/live/preview',
    name: 'appLivePreview',
    meta: {
      title: '直播预告',
    },
    component: () => import(/* webpackChunkName: "appLivePreview" */ '@/views-app/live-preview/index.vue'),
  },
];
